import { render, staticRenderFns } from "./DataCenterModernization.vue?vue&type=template&id=6a6f661b&"
import script from "./DataCenterModernization.vue?vue&type=script&lang=js&"
export * from "./DataCenterModernization.vue?vue&type=script&lang=js&"
import style0 from "./DataCenterModernization.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports